import {HttpParams} from '@angular/common/http';
import {IssueCategoryType, IssueType} from '../../common/enums/enums';

export class HttpParamsService {

  public createForIssueObservationValues(categoryType: IssueCategoryType, issueType: IssueType, templateCheckPointId: number, templateStructureId: number): HttpParams {
    let params = new HttpParams().set('categoryType', categoryType.toString());

    if (issueType != null) {
      params = params.append('issueType', issueType.toString());
    }
    if (templateCheckPointId != null && templateCheckPointId !== 0) {
      params = params.append('templateCheckPointId', templateCheckPointId.toString());
    }
    if (templateStructureId != null && templateStructureId !== 0) {
      params = params.append('templateStructureId', templateStructureId.toString());
    }

    return params;
  }
}
